/**
 * A screen which appears briefly at the end of a sponsored video giving
 * recognition to the sponsor.
 */
import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";
import type {EndOfVideoAttributionType} from "@khan/content-types";
import {staticUrl} from "@khan/urls";

import {heightOfVideoplayerControls} from "./shared-styles.ts";

export default class EndOfVideoAttribution extends React.Component<
    EndOfVideoAttributionType & {
        duration: number;
        onComplete: () => void;
    }
> {
    componentDidMount() {
        // TODO(jeff, LP-6954): Use Wonder Blocks Timing API
        // eslint-disable-next-line no-restricted-syntax
        setTimeout(this.props.onComplete, this.props.duration);
    }

    render(): React.ReactNode {
        const {logoCaption, logoUrl} = this.props;

        return (
            <div className={css(styles.root)}>
                <div className={css(styles.centered)}>
                    <img
                        className={css(styles.partnerLogo)}
                        alt={logoCaption}
                        src={staticUrl(logoUrl)}
                    />
                </div>
            </div>
        );
    }
}

const styles = StyleSheet.create({
    root: {
        backgroundColor: color.offBlack,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: 0,
        // Extend attribution down to cover video player controls.
        bottom: -heightOfVideoplayerControls,
        left: 0,
        right: 0,
    },

    centered: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
    },

    partnerLogo: {
        maxHeight: "100%",
    },
});
